module.exports = __webpack_public_path__ + "img/image2-1.249a4961.png";